import { defineComponent as u, ref as v, h as k } from "vue";
import m, { modalProps as C } from "./ghl-ui.es186.js";
const w = u({
  name: "ModalEnvironment",
  props: Object.assign(Object.assign({}, C), {
    internalKey: {
      type: String,
      required: !0
    },
    // private
    onInternalAfterLeave: {
      type: Function,
      required: !0
    }
  }),
  setup(t) {
    const i = v(!0);
    function l() {
      const {
        onInternalAfterLeave: e,
        internalKey: n,
        onAfterLeave: a
      } = t;
      e && e(n), a && a();
    }
    function r() {
      const {
        onPositiveClick: e
      } = t;
      e ? Promise.resolve(e()).then((n) => {
        n !== !1 && o();
      }) : o();
    }
    function s() {
      const {
        onNegativeClick: e
      } = t;
      e ? Promise.resolve(e()).then((n) => {
        n !== !1 && o();
      }) : o();
    }
    function c() {
      const {
        onClose: e
      } = t;
      e ? Promise.resolve(e()).then((n) => {
        n !== !1 && o();
      }) : o();
    }
    function f(e) {
      const {
        onMaskClick: n,
        maskClosable: a
      } = t;
      n && (n(e), a && o());
    }
    function d() {
      const {
        onEsc: e
      } = t;
      e && e();
    }
    function o() {
      i.value = !1;
    }
    function h(e) {
      i.value = e;
    }
    return {
      show: i,
      hide: o,
      handleUpdateShow: h,
      handleAfterLeave: l,
      handleCloseClick: c,
      handleNegativeClick: s,
      handlePositiveClick: r,
      handleMaskClick: f,
      handleEsc: d
    };
  },
  render() {
    const {
      handleUpdateShow: t,
      handleAfterLeave: i,
      handleMaskClick: l,
      handleEsc: r,
      show: s
    } = this;
    return k(m, Object.assign({}, this.$props, {
      show: s,
      onUpdateShow: t,
      onMaskClick: l,
      onEsc: r,
      onAfterLeave: i,
      internalAppear: !0,
      internalModal: !0
    }));
  }
});
export {
  w as NModalEnvironment
};
